import SummaryPanel from "./SummaryPanel";
import ReviewPanel from "./ReviewPanel";

export default function EstimateSidebar({
  estimate,
  summary,
  review,
  onRebuild,
  onOpenBoom,
  onSave,
  onChangeMarginPercent,
}) {
  return (
    <aside className="bg-[#f3f2f1]">
      <SummaryPanel
        summary={summary}
        estimate={estimate}
        onChangeMarginPercent={onChangeMarginPercent}
      />

      <ReviewPanel review={review} />

      <section className="border-b border-[#edebe9] bg-white">
        <div className="border-b border-[#edebe9] bg-[#faf9f8] px-4 py-2">
          <h3 className="text-sm font-semibold text-[#201f1e]">Tools</h3>
        </div>

        <div className="grid gap-2 p-4">
          <SidebarButton onClick={onSave}>Save</SidebarButton>
          <SidebarButton onClick={onRebuild}>Rebuild</SidebarButton>
          <SidebarButton onClick={onOpenBoom}>BOOM</SidebarButton>
        </div>
      </section>
    </aside>
  );
}

function SidebarButton({ children, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full rounded-sm border border-[#edebe9] bg-white px-3 py-2 text-left text-sm font-medium text-[#323130] hover:bg-[#f3f2f1]"
    >
      {children}
    </button>
  );
}